import { render, staticRenderFns } from "./FluidBend.vue?vue&type=template&id=92fd7852&scoped=true&"
import script from "./FluidBend.vue?vue&type=script&lang=js&"
export * from "./FluidBend.vue?vue&type=script&lang=js&"
import style0 from "./FluidBend.vue?vue&type=style&index=0&id=92fd7852&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92fd7852",
  null
  
)

export default component.exports